import { render, staticRenderFns } from "./FacturaCompraElectronica.vue?vue&type=template&id=95c657a8&scoped=true"
import script from "./FacturaCompraElectronica.vue?vue&type=script&lang=js"
export * from "./FacturaCompraElectronica.vue?vue&type=script&lang=js"
import style0 from "./FacturaCompraElectronica.vue?vue&type=style&index=0&id=95c657a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c657a8",
  null
  
)

export default component.exports